module.exports = __webpack_public_path__ + "static/media/2-solution-2.8ffed491.mp3";